import { Box, Chip, IconButton, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import Groups2Icon from "@mui/icons-material/Groups2";
import React, { useState } from "react";
import { EventoDialog } from "./EventoDialog";
import { EventoComidaDialog } from "./EventoComidaDialog";
import { AlertSuccess } from "../../utils/componentes-utiles/AlertError";
import { getTextoEncargadosEvento } from "../eventos/eventosUtils";

const tipoEventoConfig = {
	1: {
		clase: "calendar-event-food",
		label: "Menjar",
		icon: <LocalDiningIcon fontSize="inherit" />
	},
	2: {
		clase: "calendar-event-cleaning",
		label: "Neteja",
		icon: <CleaningServicesIcon fontSize="inherit" />
	},
	3: {
		clase: "calendar-event-activity",
		label: "Activitat",
		icon: <LocalActivityIcon fontSize="inherit" />
	},
	4: {
		clase: "calendar-event-clothes",
		label: "Roba",
		icon: <CheckroomIcon fontSize="inherit" />
	}
};

const contarAsistentes = (asistentes = []) => {
	return asistentes.reduce((total, asistente) => {
		const invitados = asistente.invitados || {};
		const nino1 = invitados.invitados_nino1 || invitados["invitados_niño1"] || invitados["invitados_niÃ±o1"] || 0;
		const nino2 = invitados.invitados_nino2 || invitados["invitados_niño2"] || invitados["invitados_niÃ±o2"] || 0;
		return total + (Number(asistente.miembro_asiste ?? 1) === 1 ? 1 : 0) + (invitados.invitados || 0) + nino1 + nino2;
	}, 0);
};

export const TarjetaEvento = ({ id, tarea, setDialogOpen, opTrabajadores, opciones }) => {
	const [infoOpen, setInfoOpen] = useState(false);
	const [editOpen, setEditOpen] = useState(false);
	const [succesCrearComida, setSuccesCrearComida] = useState(null);
	const tipo = tipoEventoConfig[tarea?.id_tipo_evento] || tipoEventoConfig[3];
	const asistentesTotal = contarAsistentes(tarea?.asistentes);
	const responsable = getTextoEncargadosEvento(tarea, opTrabajadores || []);
	const puedeEditar = Boolean(Number(opciones) || opciones === true);
	const usaEditorCompleto = [1, 3].includes(Number(tarea?.id_tipo_evento));

	const abrirInfo = (event) => {
		event?.stopPropagation();
		setInfoOpen(true);
	};

	const abrirEditor = (event) => {
		event?.stopPropagation();
		setEditOpen(true);
	};

	return (
		<Box className={`calendar-event-card ${tipo.clase}`}>
			<Stack className="calendar-event-main">
				<Box className="calendar-event-topline">
					<span className="calendar-event-icon">{tipo.icon}</span>
					<Typography className="calendar-event-title" title={tarea?.asunto} onClick={abrirEditor}>
						{tarea?.asunto}
					</Typography>
					<IconButton className="calendar-event-info" size="small" onClick={abrirInfo}>
						<InfoOutlinedIcon fontSize="small" />
					</IconButton>
				</Box>

				<Stack direction="row" className="calendar-event-meta">
					<Chip size="small" label={tarea?.hora_inicio || "--:--"} className="calendar-event-time-chip" />
					{asistentesTotal > 0 && (
						<span className="calendar-event-attendees">
							<Groups2Icon fontSize="inherit" />
							{asistentesTotal}
						</span>
					)}
				</Stack>

				{responsable.texto !== "Sense assignar" && (
					<Typography className="calendar-event-owner">
						{responsable.texto}
					</Typography>
				)}
			</Stack>

			<EventoDialog open={infoOpen} setOpen={setInfoOpen} tarea={tarea} opTrabajadores={opTrabajadores} />
			{usaEditorCompleto && puedeEditar && (
				<EventoComidaDialog
					open={editOpen}
					setOpen={setEditOpen}
					tarea={tarea}
					opTrabajadores={opTrabajadores}
					setSuccesCrearComida={setSuccesCrearComida}
					opciones={opciones}
				/>
			)}
			{succesCrearComida && (
				<AlertSuccess open={succesCrearComida} setOpen={setSuccesCrearComida} titulo={"Èxit"} mensaje={"Canvis realitzats correctament"} tipo={"success"} />
			)}
		</Box>
	);
};
